import React from "react";

import { useDialogModal } from "@/hooks/useDialogModal";
import { Button } from "@/components/ui/button";

const AlertButton = ({ label, message }) => {
  const { dialogElement, alert } = useDialogModal();

  return (
    <>
      {dialogElement}
      <Button onClick={() => alert(label, message)}>{label}</Button>
    </>
  );
};

export { AlertButton };
